import React from 'react'
import { action } from '@storybook/addon-actions'
import { storiesOf } from '@storybook/react'

import QuizTab from 'routes/Game/screens/RegularGameScreen/components/QuizTab'
import { IQuizSection, QuizQuestion } from 'protos'

const fakeQuizSections: IQuizSection[] = [
  {
    title: 'Daily Challenge (upcoming)',
    iconUrl: 'https://place-hold.it/64x64',
    question: [
      {
        questionId: 'question-1',
        title: '**Who wins the match?**',
        subtitle: 'Pick one answer.',
        iconUrl: 'https://place-hold.it/48x48',
        outcome: QuizQuestion.Outcome.QQ_UNKNOWN,
        editable: true,
        answer: [
          {
            answerId: 'answer-1-1',
            longText: 'Bayern Munchen',
            shortText: '1',
          },
          {
            answerId: 'answer-1-2',
            longText: 'Draw',
            shortText: 'X',
          },
          {
            answerId: 'answer-1-3',
            longText: 'Kecel FC',
            shortText: '2',
          },
        ],
      },
      {
        questionId: 'question-2',
        title: '**Who wins the match?**',
        subtitle: 'Pick one answer.',
        iconUrl: 'https://place-hold.it/48x48',
        outcome: QuizQuestion.Outcome.QQ_UNKNOWN,
        selectedAnswerId: 'answer-2-2',
        editable: true,
        answer: [
          {
            answerId: 'answer-2-1',
            longText: 'Bayern Munchen',
            shortText: '1',
          },
          {
            answerId: 'answer-2-2',
            longText: 'Draw',
            shortText: 'X',
          },
          {
            answerId: 'answer-2-3',
            longText: 'Kecel FC',
            shortText: '2',
          },
        ],
      },
      {
        questionId: 'question-3',
        title: '**Coming soon**',
        subtitle: 'Check back later.',
        iconUrl: 'https://place-hold.it/48x48',
        outcome: QuizQuestion.Outcome.QQ_UNKNOWN,
      },
    ],
  },
  {
    title: 'Daily Challenge (finished)',
    iconUrl: 'https://place-hold.it/64x64',
    question: [
      {
        questionId: 'question-2',
        title: '**Who wins the match?**',
        subtitle: 'Pick one answer.',
        iconUrl: 'https://place-hold.it/48x48',
        outcome: QuizQuestion.Outcome.QQ_CORRECT,
        selectedAnswerId: 'answer-2-1',
        answer: [
          {
            answerId: 'answer-2-1',
            longText: 'Bayern Munchen',
            shortText: '1',
          },
          {
            answerId: 'answer-2-2',
            longText: 'Draw',
            shortText: 'X',
          },
          {
            answerId: 'answer-2-3',
            longText: 'Kecel FC',
            shortText: '2',
          },
        ],
      },
      {
        questionId: 'question-1',
        title: '**Who wins the match?**',
        subtitle: 'Pick one answer.',
        iconUrl: 'https://place-hold.it/48x48',
        outcome: QuizQuestion.Outcome.QQ_INCORRECT,
        selectedAnswerId: 'answer-1-1',
        answer: [
          {
            answerId: 'answer-1-1',
            longText: 'Bayern Munchen',
            shortText: '1',
          },
          {
            answerId: 'answer-1-2',
            longText: 'Draw',
            shortText: 'X',
          },
          {
            answerId: 'answer-1-3',
            longText: 'Kecel FC',
            shortText: '2',
          },
        ],
      },
      {
        questionId: 'question-3',
        title: '**Who wins the match?**',
        subtitle: 'Pick one answer.',
        iconUrl: 'https://place-hold.it/48x48',
        outcome: QuizQuestion.Outcome.QQ_UNANSWERED,
        answer: [
          {
            answerId: 'answer-3-1',
            longText: 'Bayern Munchen',
            shortText: '1',
          },
          {
            answerId: 'answer-3-2',
            longText: 'Draw',
            shortText: 'X',
          },
          {
            answerId: 'answer-3-3',
            longText: 'Kecel FC',
            shortText: '2',
          },
        ],
      },
    ],
  },
  {
    title: 'Totally empty section',
    iconUrl: 'https://place-hold.it/64x64',
  }
]

storiesOf('QuizTab', module)
  .add('default', () => (
    <QuizTab
      gameDetails={{
        quiz: fakeQuizSections,
        quizOutcomeImageUrl: 'https://place-hold.it/128x128',
        quizOutcomeTitle: '**Congratulations!**',
        quizOutcomeMessage: 'You answered 2/3 correct.  \nYour points multiple is ***1.2**',
      }}
      onAnswerSubmit={action('Submit answer to the server')}
    />
  ))
